module.exports = __webpack_public_path__ + "img/primary-arrow-in-circle.beafb829.svg";